'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _enum = require('../enum');

var _Pharma = require('../actions/Pharma');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  pharmaProducts: undefined,
  pharmaProductsLoadState: _enum.status.SHOULD_CALL_API,
  prevAddedMedications: undefined,
  prevAddedMedicationsLoadState: _enum.status.SHOULD_CALL_API,
  prescriptionSettings: undefined,
  prescriptionSettingsLoadState: _enum.status.SHOULD_CALL_API,
  dosageSelectionModal: false,
  displayEPrescModalIsOpened: false,
  displayPrescModalIsOpened: false,
  selectedMedicationItemDetails: undefined,
  presciptionMedicationsList: [],
  submitEprescriptionLoadState: _enum.status.SHOULD_CALL_API,
  ePrescDetails: undefined,
  ePrescDetailsLoadState: _enum.status.SHOULD_CALL_API,
  prescImages: undefined,
  prescImagesLoadState: _enum.status.SHOULD_CALL_API
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _Pharma.PHARMA.GET_PRESC.LOAD:
      {
        return _extends({}, state, {
          prescImagesLoadState: _enum.status.FETCHING
        });
      }

    case _Pharma.PHARMA.GET_PRESC.SUCCESS:
      {
        return _extends({}, state, {
          prescImages: payload.payload,
          prescImagesLoadState: _enum.status.SUCCESS
        });
      }

    case _Pharma.PHARMA.GET_PRESC.FAIL:
      {
        return _extends({}, state, {
          prescImagesLoadState: _enum.status.FAIL
        });
      }

    case _Pharma.PHARMA.GET_EPRESC.LOAD:
      {
        return _extends({}, state, {
          ePrescDetailsLoadState: _enum.status.FETCHING
        });
      }

    case _Pharma.PHARMA.GET_EPRESC.SUCCESS:
      {
        return _extends({}, state, {
          ePrescDetails: payload.payload,
          ePrescDetailsLoadState: _enum.status.SUCCESS
        });
      }

    case _Pharma.PHARMA.GET_EPRESC.FAIL:
      {
        return _extends({}, state, {
          ePrescDetailsLoadState: _enum.status.FAIL
        });
      }
    case _Pharma.PHARMA.DISPLAY_EPRESC_MODAL.TOGGLE_DISPLAY_EPRESC_MODAL:
      {
        return _extends({}, state, {
          displayEPrescModalIsOpened: payload.isOpened
        });
      }
    case _Pharma.PHARMA.DISPLAY_PRESC_MODAL.TOGGLE_DISPLAY_PRESC_MODAL:
      {
        return _extends({}, state, {
          displayPrescModalIsOpened: payload.isOpened
        });
      }
    case _Pharma.PHARMA.RESET_MEDICATION_TO_PRESCRIPTION_LIST:
      {
        return _extends({}, state, {
          presciptionMedicationsList: [],
          prescriptionSettings: undefined,
          prescriptionSettingsLoadState: _enum.status.SHOULD_CALL_API
        });
      }
    case _Pharma.PHARMA.SUBMIT_EPRESCRIPTION.SUBMIT:
      {
        return _extends({}, state, {
          submitEprescriptionLoadState: _enum.status.SUBMITING
        });
      }
    case _Pharma.PHARMA.SUBMIT_EPRESCRIPTION.SUCCESS:
      {
        return _extends({}, state, {
          submitEprescriptionLoadState: _enum.status.SUCCESS
        });
      }
    case _Pharma.PHARMA.SUBMIT_EPRESCRIPTION.FAIL:
      {
        return _extends({}, state, {
          submitEprescriptionLoadState: _enum.status.FAIL
        });
      }
    case _Pharma.PHARMA.ADD_MEDICATION_TO_PRESCRIPTION_LIST:
      {
        var presciptionMedicationsList = state.presciptionMedicationsList;

        var indexOfPorduct = presciptionMedicationsList.findIndex(function (item) {
          return item.productKey === payload.payload.productKey;
        });
        if (indexOfPorduct === -1) {
          var _updatedList = [].concat(presciptionMedicationsList, [payload.payload]);
          return _extends({}, state, {
            presciptionMedicationsList: _updatedList
          });
        }
        var updatedList = [].concat(presciptionMedicationsList);
        updatedList[indexOfPorduct] = payload.payload;
        return _extends({}, state, {
          presciptionMedicationsList: updatedList
        });
      }
    case _Pharma.PHARMA.REMOVE_MEDICATION_FROM_PRESCRIPTION_LIST:
      {
        var listAfterRemovingItem = state.presciptionMedicationsList.filter(function (item) {
          return item.productKey !== payload.productKey;
        });
        return _extends({}, state, {
          presciptionMedicationsList: listAfterRemovingItem
        });
      }
    case _Pharma.PHARMA.EDIT_MEDICATION:
      {
        var getMedicationToBeEdited = state.presciptionMedicationsList.filter(function (item) {
          return item.productKey === payload.productKey;
        });
        return _extends({}, state, {
          selectedMedicationItemDetails: getMedicationToBeEdited && getMedicationToBeEdited[0]
        });
      }
    case _Pharma.PHARMA.SET_SELECTED_MEDICATION_ITEM:
      {
        return _extends({}, state, {
          selectedMedicationItemDetails: payload.payload
        });
      }
    case _Pharma.PHARMA.DOSAGE_SELECTION_MODAL.TOGGLE_DOSAGE_SELECTION_MODAL:
      {
        return _extends({}, state, {
          dosageSelectionModal: payload.isOpened
        });
      }
    case _Pharma.PHARMA.PHARMA_PRODUCTS.LOAD:
      {
        return _extends({}, state, {
          pharmaProductsLoadState: _enum.status.FETCHING
        });
      }

    case _Pharma.PHARMA.PHARMA_PRODUCTS.SUCCESS:
      {
        return _extends({}, state, {
          pharmaProducts: payload.payload,
          pharmaProductsLoadState: _enum.status.SUCCESS
        });
      }

    case _Pharma.PHARMA.PHARMA_PRODUCTS.FAIL:
      {
        return _extends({}, state, {
          pharmaProductsLoadState: _enum.status.FAIL
        });
      }
    case _Pharma.PHARMA.GET_PREVIOUSLY_ADDED_MEDICATIONS.LOAD:
      {
        return _extends({}, state, {
          prevAddedMedicationsLoadState: _enum.status.FETCHING
        });
      }

    case _Pharma.PHARMA.GET_PREVIOUSLY_ADDED_MEDICATIONS.SUCCESS:
      {
        return _extends({}, state, {
          prevAddedMedications: payload.payload,
          prevAddedMedicationsLoadState: _enum.status.SUCCESS
        });
      }

    case _Pharma.PHARMA.GET_PREVIOUSLY_ADDED_MEDICATIONS.FAIL:
      {
        return _extends({}, state, {
          prevAddedMedicationsLoadState: _enum.status.FAIL
        });
      }
    case _Pharma.PHARMA.GET_PRESCRIPTION_SETTINGS.LOAD:
      {
        return _extends({}, state, {
          prescriptionSettingsLoadState: _enum.status.FETCHING
        });
      }

    case _Pharma.PHARMA.GET_PRESCRIPTION_SETTINGS.SUCCESS:
      {
        return _extends({}, state, {
          prescriptionSettings: payload.payload,
          prescriptionSettingsLoadState: _enum.status.SUCCESS
        });
      }

    case _Pharma.PHARMA.GET_PRESCRIPTION_SETTINGS.FAIL:
      {
        return _extends({}, state, {
          prescriptionSettingsLoadState: _enum.status.FAIL
        });
      }

    default:
      return state;
  }
};

module.exports = exports['default'];